<div class="diff-table">
  <cc-form-table-core [readonlyFormulas]="true" [model]="field" [hasLeftActions]="false"></cc-form-table-core>
</div>
